export default __webpack_public_path__ + "static/media/hinge2.3932bbd1.jpg";